export class IssueSubmissionResponse {
  policyNumber: string;
  jobNumber: string;
}
